<template>
  <thux-table
    :instance="instance"
    :instance-name="instanceName"
    :order-by-dict="orderByDict"
    :goBack="goBack"
    :list="list"
    :fieldName="fieldName"
    :fields="fields"
    :fields-column="fieldsColumn"
    :select-all="selectAll"
    :selected-list="selectedList"
    :get-local-selected-all="getLocalSelectedAll"
    :local-selected-list="localSelectedList"
    @check-all="checkAll"
    @check-none="checkNone"
    @set-selected-row="setSelectedRow"
    :show-checks="showChecks"
    :showDetailButton="showDetailButton"
    @change-status="changeInstanceStatus"
    @sort-changed="orderTable"
    @remove-order-by="removeOrderFromTable"
    @open-detail-form="$emit('open-detail-form', $event)"
  />
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as PAYMENT_FORM_TYPES } from './store'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxTableMixin from '../../../components/thux-table/ThuxTableMixin'
import ThuxTableChecksMixin from '../../../components/thux-table/thux-table-checks/ThuxTableChecksMixin'

export default {
  name: 'PaymentFormTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin],
  data () {
    return {
      fields: [
        {
          key: 'checks',
          label: this.$t('Checks')
        },
        {
          key: 'status',
          label: this.$t('Status'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'status'
        },
        {
          key: 'code',
          label: this.$t('Code'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'code'
        },
        {
          key: 'name',
          label: this.$t('Name'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'name'
        },
        {
          key: 'fee',
          label: this.$t('Fee'),
          type: 'text',
          thClass: 'text-nowrap text-right',
          tdClass: 'text-nowrap text-right',
          sortable: true,
          value: 'fee'
        },
        {
          key: 'discount',
          label: this.$t('Discount'),
          type: 'text',
          thClass: 'text-nowrap text-right',
          tdClass: 'text-nowrap text-right',
          sortable: true,
          value: 'discount'
        },
        {
          key: 'description',
          label: this.$t('Description'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'description'
        },
        {
          key: 'action',
          label: this.$t('Actions'),
          tdClass: 'text-right text-nowrap',
          thClass: 'text-right text-nowrap'
        }
      ],
      fieldsColumn: ['status', 'code', 'name', 'fee', 'discount', 'description']
    }
  },
  computed: {
    ...mapGetters({
      selectAll: PAYMENT_FORM_TYPES.GENERIC.payment.paymentform.LIST.GETTERS.selectAll,
      selectedList: PAYMENT_FORM_TYPES.GENERIC.payment.paymentform.LIST.GETTERS.selectedList
    }),
    showChecks () {
      return true
    },
    showDetailButton () {
      return hasPerm('payment_paymentform_retrieve')
    }
  },
  methods: {
    ...mapMutations({
      setList: PAYMENT_FORM_TYPES.GENERIC.payment.paymentform.LIST.MUTATIONS.setList,
      setSelectedList:
        PAYMENT_FORM_TYPES.GENERIC.payment.paymentform.LIST.MUTATIONS.setSelectedList,
      setSelectAll: PAYMENT_FORM_TYPES.GENERIC.payment.paymentform.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...PAYMENT_FORM_TYPES.GENERIC.payment.paymentform.LIST.ACTIONS
    })
  }
}
</script>
